/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import HttpProvider from '@/services/HttpProvider'
import Config from '@/config'
import Logger from '@/services/Logger'
import actions from '@/store/modules/category/actions'
import { restWithCache } from '@/store/lib/search'

function extendChildCategory (child, parent) {
  const metaKeyworld = child.custom_attributes.find((attr) => {
    return attr.attribute_code === 'meta_keywords'
  })
  if (metaKeyworld && metaKeyworld.value.includes('{link_parent}')) {
    child.url_path = parent.url_path
  }
}

function recursiveBuildTree (currentCategory, categories) {
  let childrenIds, child, tmp
  currentCategory.childrenAllIds = []
  if (currentCategory.is_active) {
    Vue.set(currentCategory, 'childrenData', [])
    childrenIds = currentCategory.children ? currentCategory.children.split(',') : []
    currentCategory.childrenAllIds = childrenIds.length ? [...childrenIds] : []
    childrenIds.forEach(childId => {
      child = categories.find(item => item.id === parseInt(childId))
      if (child && child.is_active) {
        tmp = recursiveBuildTree(child, categories)
        currentCategory.childrenAllIds = currentCategory.childrenAllIds.concat(tmp.childrenAllIds)
        extendChildCategory(tmp, currentCategory)
        currentCategory.childrenData.push(tmp)
      }
    })
  }
  return currentCategory
}

function createTree (firstCategory, categories) {
  let tree = null
  if (firstCategory) {
    tree = recursiveBuildTree(firstCategory, categories)
  }
  return tree
}

actions.load = (ctx) => {
  let listStoreView = ctx.rootState.ui.storeViewCode
  if (ctx.state.list.length && listStoreView === ctx.rootState.ui.storeViewCode) {
    return Promise.resolve(ctx.state.list)
  }
  Logger.debug('start load category -->', ctx.rootState.ui.storeViewCode, ctx.rootState.ui.dateTime)
  const rootCategoryID = ctx.rootGetters['storeConfig/rootCategoryId']
  // Add search criteria for all categories
  let searchCriteria = `searchCriteria[filter_groups][0][filters][0][field]=path&searchCriteria[filter_groups][0][filters][0][value]=%25${rootCategoryID}%25&searchCriteria[filter_groups][0][filters][0][condition_type]=like`
  let query = Config.API.catalog.categories.replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode).replace('searchCriteria', searchCriteria)
  return restWithCache({
    query,
    restPromise: HttpProvider.get(query, {
      headers: {
        'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
      }
    })
  })
    .then(category => {
      Logger.debug('load category -->', ctx.rootState.ui.storeViewCode, ctx.rootState.ui.dateTime)
      ctx.commit('saveFlatted', category.items)
      let rootCat = category.items.find(item => item.id === rootCategoryID)
      listStoreView = ctx.rootState.ui.storeViewCode
      return createTree(rootCat, category.items)
    })
    .then((categoryTree) => {
      ctx.commit('saveList', categoryTree.childrenData)
      ctx.commit('saveRoot', categoryTree)
      return categoryTree.childrenData
    })
}

export default {
  ...actions
}
